export const americanize = (str: string) => str.replace(/^centre$/, 'center');
